import { WorkstreamTemplateLibrary } from "@/components/admin/WorkstreamTemplateLibrary";

export function SettingsWorkstreamTemplatesPage() {
  return <WorkstreamTemplateLibrary />;
}
